import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

@Component({
  selector: '[app-toast-component]',
  templateUrl: './toast.component.html',
  // eslint-disable-next-line @angular-eslint/component-max-inline-declarations -- No great way to simplify this
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      transition(
        'inactive => active',
        animate(
          '400ms ease-out',
          keyframes([
            style({ transform: 'translate3d(100%, 0, 0) skewX(-30deg)', opacity: 0 }),
            style({ transform: 'skewX(20deg)', opacity: 1 }),
            style({ transform: 'skewX(-5deg)', opacity: 1 }),
            style({ transform: 'none', opacity: 1 }),
          ]),
        ),
      ),
      transition(
        'active => removed',
        animate(
          '300ms ease-in',
          keyframes([style({ opacity: 1 }), style({ transform: 'translate3d(100%, 0, 0) skewX(30deg)', opacity: 0 })]),
        ),
      ),
    ]),
  ],
  preserveWhitespaces: false,
  standalone: false,
})
export class ToastComponent extends Toast {
  action(event: Event) {
    event.stopPropagation();
    this.toastPackage.triggerAction();
    return false;
  }
}
